module.exports = __webpack_public_path__ + "img/lottie-audio-waves.785a2fae.gif";